const LoginPageText = {
  LoginButton_Label: 'ログイン',
  Login_Disc: 'TOPCONアカウントでログインしてください。',
  Forget_Password: 'パスワードを忘れた場合はこちら',
  HaveNot_Account: 'アカウントを持っていない場合',
  Register_Account: '登録はこちら',
  Activation_Resend: 'アクティベーションメールを再送する',
} as const;

export default LoginPageText;
